import React from 'react';
import TextAreaComponent from './TextAreaComponent';

const SpecialInstruction = (props) => {
  const { parameters, onChangeParameter, groupName, rows } = props;
  const name = 'special_instructions';
  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <TextAreaComponent
      label="Special Instruction"
      name={name}
      onChange={onChange}
      value={parameters[name] || ''}
      groupName={groupName}
      rows={rows} />
  );
};

export default SpecialInstruction;
